import { Campaign } from '@/dashboards/CampaignPlanner/types';

export const getCampaignFlightStatus = (campaign: Campaign) => {
    const now = new Date();
    const startDate = new Date(campaign.startDate);
    const endDate = new Date(campaign.endDate);
    const isActive = now >= startDate && now <= endDate;
    const isUpcoming = now < startDate;

    if (isActive)
        return {
            label: 'In flight',
            color: 'bg-green-100 text-green-700 border-green-200',
        };
    if (isUpcoming)
        return {
            label: 'Planned',
            color: 'bg-blue-100 text-blue-700 border-blue-200',
        };
    return {
        label: 'Past',
        color: 'bg-gray-100 text-gray-700 border-gray-200',
    };
};
